export enum ColorPickerCloseRequestType {
    GRADIENT_CLICK = 'GRADIENT_CLICK',
    HUE_CLICK = 'HUE_CLICK',
    SWATCH_CLICK = 'SWATCH_CLICK',
    MANAGE_FAVORITE_CLICK = 'MANAGE_FAVORITE_CLICK'
}
